import baseColumns from './base-columns';

export default function SocialMediaColumns(params: any) {
  const {
    isSpecialChannel,
    filterBoxValue = {},
    gameInfo,
    ...otherInfo
  } = params;
  const { languages, renderKey, topicList } = filterBoxValue;

  const languageSort = ['origin', 'en', 'zh'];
  const languageList = languageSort.filter((a: any) => languages?.includes(a));

  const { edition_unified_id } = gameInfo;

  let keys = [
    'channelName',
    ...languageList,
    'validation',
    'monitoring',
    'commentTime',
    'language',
    'topic',
    'engagement',
    'like',
    'share',
    'comment',
    'view',
    'follower',
  ];

  if (isSpecialChannel) {
    if (edition_unified_id === 'ebaf4c80cdf9f22c672b348e8b19d57c8') {
      keys = [
        'channelName',
        ...languageList,
        'validation',
        'monitoring',
        'commentTime2',
        'updateTime',
        'view',
        'tweetsReply',
        'language',
        'topic',
      ];
    }
    if (
      edition_unified_id === 'u10000000066' ||
      edition_unified_id === 'u10000000022' ||
      edition_unified_id === 'u6d721eb69ef7de198bb84be26be6d40b'
    ) {
      keys = [
        'channelName',
        ...languageList,
        'validation',
        'monitoring',
        'commentTime',
        'language',
        'topic',
      ];
    }

    if (edition_unified_id === 'u10000000028') {
      keys = [
        'channelName',
        ...languageList,
        'validation',
        'monitoring',
        'commentTime',
        'language',
        'topic',
        'ctgr1',
        'ctgr2',
        'ctgr3',
      ];
    }

    if (edition_unified_id === 'e11000000297') {
      keys = [
        'channelName',
        ...languageList,
        'validation',
        'reactions',
        'like2',
        'comment',
        'commentTime',
        'language',
        'topic',
      ];
    }
  }

  const columns = baseColumns(keys, {
    ...otherInfo,
    renderKey,
    firstLanguage: languageList[0],
    topicList,
  });

  return columns;
}
